import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sidebar-head" }
const _hoisted_2 = {
  key: 0,
  class: "sidebar-brand"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["aria-label", "data-tooltip"]
const _hoisted_5 = { class: "sidebar-nav" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_8 = {
  key: 1,
  class: "nav-kbd"
}
const _hoisted_9 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_10 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_11 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_12 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_13 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_14 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_15 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_16 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_17 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_18 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_19 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_20 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_21 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_22 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_23 = { class: "sidebar-shortcuts" }
const _hoisted_24 = ["aria-label"]
const _hoisted_25 = {
  key: 0,
  class: "nav-label"
}
const _hoisted_26 = {
  key: 1,
  class: "nav-kbd"
}
const _hoisted_27 = {
  key: 0,
  class: "sidebar-footer"
}
const _hoisted_28 = {
  key: 0,
  class: "nav-label"
}

import { computed } from 'vue'
import { useStore } from 'vuex'
import { usePermission } from '@/composables/usePermission'
import { openGlobalSearch } from '@/composables/useGlobalSearch'
import { toggleShortcutsHelp } from '@/composables/useShortcutsHelp'
import { useLogo } from '@/composables/useLogo'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  props: {
    collapsed: { type: Boolean }
  },
  emits: ["update:collapsed"],
  setup(__props: any) {

const { logoUrl } = useLogo()





const store   = useStore()
const { can } = usePermission()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["sidebar", { 'sidebar--collapsed': __props.collapsed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.collapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(logoUrl),
              alt: "ISBET",
              class: "sidebar-brand-img"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "sidebar-toggle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:collapsed', !__props.collapsed))),
        "aria-label": __props.collapsed ? 'Expandir menu' : 'Recolher menu',
        "data-tooltip": __props.collapsed ? 'Expandir menu' : 'Recolher menu'
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("svg", {
          width: "18",
          height: "18",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("line", {
            x1: "3",
            y1: "6",
            x2: "21",
            y2: "6"
          }),
          _createElementVNode("line", {
            x1: "3",
            y1: "12",
            x2: "21",
            y2: "12"
          }),
          _createElementVNode("line", {
            x1: "3",
            y1: "18",
            x2: "21",
            y2: "18"
          })
        ], -1)
      ]))], 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "nav-item nav-item--search",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openGlobalSearch) && _unref(openGlobalSearch)(...args))),
        "aria-label": __props.collapsed ? 'Buscar (Ctrl+K)' : undefined,
        "data-tooltip": "Buscar · Ctrl+K"
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "nav-icon" }, [
          _createElementVNode("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "11",
              cy: "11",
              r: "8"
            }),
            _createElementVNode("line", {
              x1: "21",
              y1: "21",
              x2: "16.65",
              y2: "16.65"
            })
          ])
        ], -1)),
        (!__props.collapsed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Buscar"))
          : _createCommentVNode("", true),
        (!__props.collapsed)
          ? (_openBlock(), _createElementBlock("kbd", _hoisted_8, "Ctrl K"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_6),
      _createVNode(_component_router_link, {
        to: "/",
        class: "nav-item",
        "exact-active-class": "nav-item--active",
        "aria-label": __props.collapsed ? 'Dashboard' : undefined,
        "data-tooltip": "Dashboard"
      }, {
        default: _withCtx(() => [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "nav-icon" }, [
            _createElementVNode("svg", {
              width: "18",
              height: "18",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("rect", {
                x: "3",
                y: "3",
                width: "7",
                height: "7",
                rx: "1"
              }),
              _createElementVNode("rect", {
                x: "14",
                y: "3",
                width: "7",
                height: "7",
                rx: "1"
              }),
              _createElementVNode("rect", {
                x: "3",
                y: "14",
                width: "7",
                height: "7",
                rx: "1"
              }),
              _createElementVNode("rect", {
                x: "14",
                y: "14",
                width: "7",
                height: "7",
                rx: "1"
              })
            ])
          ], -1)),
          (!__props.collapsed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Dashboard"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["aria-label"]),
      (_unref(can)('foco.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/foco",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Modo Foco' : undefined,
            "data-tooltip": "Modo Foco"
          }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9"
                  }),
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "4"
                  }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "1",
                    x2: "12",
                    y2: "4"
                  }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "20",
                    x2: "12",
                    y2: "23"
                  }),
                  _createElementVNode("line", {
                    x1: "1",
                    y1: "12",
                    x2: "4",
                    y2: "12"
                  }),
                  _createElementVNode("line", {
                    x1: "20",
                    y1: "12",
                    x2: "23",
                    y2: "12"
                  })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Modo Foco"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('templates.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/templates",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Templates WA' : undefined,
            "data-tooltip": "Templates WA"
          }, {
            default: _withCtx(() => [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Templates WA"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('resumo.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "/resumo",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Resumo' : undefined,
            "data-tooltip": "Resumo"
          }, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("rect", {
                    x: "2",
                    y: "3",
                    width: "5",
                    height: "5",
                    rx: "1"
                  }),
                  _createElementVNode("rect", {
                    x: "9",
                    y: "3",
                    width: "5",
                    height: "5",
                    rx: "1"
                  }),
                  _createElementVNode("rect", {
                    x: "16",
                    y: "3",
                    width: "6",
                    height: "5",
                    rx: "1"
                  }),
                  _createElementVNode("rect", {
                    x: "2",
                    y: "11",
                    width: "5",
                    height: "10",
                    rx: "1"
                  }),
                  _createElementVNode("rect", {
                    x: "9",
                    y: "11",
                    width: "5",
                    height: "6",
                    rx: "1"
                  }),
                  _createElementVNode("rect", {
                    x: "16",
                    y: "11",
                    width: "6",
                    height: "8",
                    rx: "1"
                  })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Resumo"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('relatorioResolucao.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            to: "/relatorio-resolucao",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Relatório de Resolução' : undefined,
            "data-tooltip": "Relatório de Resolução"
          }, {
            default: _withCtx(() => [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M9 11l3 3L22 4" }),
                  _createElementVNode("path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Relatório de Resolução"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('contacts.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 4,
            to: "/contacts",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Contatos' : undefined,
            "data-tooltip": "Contatos"
          }, {
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                  _createElementVNode("circle", {
                    cx: "9",
                    cy: "7",
                    r: "4"
                  }),
                  _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Contatos"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('sla.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 5,
            to: "/sla",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'SLA' : undefined,
            "data-tooltip": "SLA"
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "10"
                  }),
                  _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "SLA"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('teams.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 6,
            to: "/teams",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Times' : undefined,
            "data-tooltip": "Times"
          }, {
            default: _withCtx(() => [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                  _createElementVNode("circle", {
                    cx: "9",
                    cy: "7",
                    r: "4"
                  }),
                  _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Times"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('macros.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 7,
            to: "/macros",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Macros' : undefined,
            "data-tooltip": "Macros"
          }, {
            default: _withCtx(() => [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polygon", { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Macros"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('avaliacoes.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 8,
            to: "/avaliacoes",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Avaliações' : undefined,
            "data-tooltip": "Avaliações"
          }, {
            default: _withCtx(() => [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polygon", { points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Avaliações"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('fila.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 9,
            to: "/fila",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Fila de Chamados' : undefined,
            "data-tooltip": "Fila de Chamados"
          }, {
            default: _withCtx(() => [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("line", {
                    x1: "8",
                    y1: "6",
                    x2: "21",
                    y2: "6"
                  }),
                  _createElementVNode("line", {
                    x1: "8",
                    y1: "12",
                    x2: "21",
                    y2: "12"
                  }),
                  _createElementVNode("line", {
                    x1: "8",
                    y1: "18",
                    x2: "21",
                    y2: "18"
                  }),
                  _createElementVNode("line", {
                    x1: "3",
                    y1: "6",
                    x2: "3.01",
                    y2: "6"
                  }),
                  _createElementVNode("line", {
                    x1: "3",
                    y1: "12",
                    x2: "3.01",
                    y2: "12"
                  }),
                  _createElementVNode("line", {
                    x1: "3",
                    y1: "18",
                    x2: "3.01",
                    y2: "18"
                  })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Fila"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('agentes.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 10,
            to: "/agentes",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Agentes' : undefined,
            "data-tooltip": "Agentes"
          }, {
            default: _withCtx(() => [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "7",
                    r: "4"
                  }),
                  _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" }),
                  _createElementVNode("path", { d: "M21 21v-2a4 4 0 0 0-3-3.87" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Agentes"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('etiquetas.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 11,
            to: "/etiquetas",
            class: "nav-item",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Etiquetas' : undefined,
            "data-tooltip": "Etiquetas"
          }, {
            default: _withCtx(() => [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" }),
                  _createElementVNode("line", {
                    x1: "7",
                    y1: "7",
                    x2: "7.01",
                    y2: "7"
                  })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Etiquetas"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true),
      (_unref(can)('slaMetro.view'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 12,
            to: "/sla-metro",
            class: "nav-item nav-item--metro",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'SLA Metro (Telão)' : undefined,
            "data-tooltip": "SLA Metro (Telão)"
          }, {
            default: _withCtx(() => [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "9",
                    x2: "12",
                    y2: "13"
                  }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "17",
                    x2: "12.01",
                    y2: "17"
                  })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "SLA Telão"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("button", {
        class: "nav-item nav-item--shortcuts",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggleShortcutsHelp) && _unref(toggleShortcutsHelp)(...args))),
        "aria-label": __props.collapsed ? 'Atalhos de teclado (?)' : undefined,
        "data-tooltip": "Atalhos de teclado · ?"
      }, [
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "nav-icon nav-icon--shortcuts" }, "?", -1)),
        (!__props.collapsed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Atalhos"))
          : _createCommentVNode("", true),
        (!__props.collapsed)
          ? (_openBlock(), _createElementBlock("kbd", _hoisted_26, "?"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_24)
    ]),
    (_unref(can)('admin.view'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_router_link, {
            to: "/admin",
            class: "nav-item nav-item--admin",
            "active-class": "nav-item--active",
            "aria-label": __props.collapsed ? 'Admin' : undefined,
            "data-tooltip": "Admin"
          }, {
            default: _withCtx(() => [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "nav-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" })
                ])
              ], -1)),
              (!__props.collapsed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Admin"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["aria-label"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})